export default __webpack_public_path__ + "static/media/recording-on-red.af1e4db7.svg";